module.exports = __webpack_public_path__ + "static/1.2_543x300_Pill_Mobile_2X-8235ca2dd45ecdb1587685df567eebf6.png";